import LocataireFields from "./LocataireFields"
import { useLocationForm } from './LocationFormContext'
import NewLocationFields from './NewLocationFields'

export default () => {
  // Récupérer les valeurs du contexte
  const { control, formErrors, errors } = useLocationForm()

  return (
    <div className={`grid grid-cols-1 md:grid-cols-3 gap-4`}>
      <div className="flex flex-col items-start gap-4">  
        <LocataireFields control={control} formErrors={formErrors} apiErrors={errors} />
      </div>

      <div className="flex flex-col items-start gap-4">  
        <NewLocationFields.Values />
      </div>

      <div className="flex flex-col items-start gap-4">  
        <NewLocationFields.Files />
      </div>

    </div>
  )
}